// @file Vue composable for all menu related logic in Slideshow

import { useSlideshowStore } from '@@/pinia/slideshow'
import { storeToRefs } from 'pinia'
import type { Ref } from 'vue'

export const useSlideshowMenus = (): {
  isMoreMenuOpen: Ref<boolean>
  isAutoplayMenuOpen: Ref<boolean>
  isAnyMenuOpen: Ref<boolean>
} => {
  const { isMoreMenuOpen, isAutoplayMenuOpen, isAnyMenuOpen } = storeToRefs(useSlideshowStore())

  return {
    isMoreMenuOpen,
    isAutoplayMenuOpen,
    isAnyMenuOpen,
  }
}
